/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FleetRoleResourceAccessEnum = typeof FleetRoleResourceAccessEnum[keyof typeof FleetRoleResourceAccessEnum];


export const FleetRoleResourceAccessEnum = {
  FLEET_UPDATE: 'fleet:update',
  FLEET_UPDATE_IMAGES: 'fleet:update:images',
  FLEET_UPDATE_DESCRIPTION: 'fleet:update:description',
  FLEET_DELETE: 'fleet:delete',
  FLEET_MANAGE: 'fleet:manage',
  FLEET_MEMBERSHIPS_READ: 'fleet:memberships:read',
  FLEET_MEMBERSHIPS_CREATE: 'fleet:memberships:create',
  FLEET_MEMBERSHIPS_UPDATE: 'fleet:memberships:update',
  FLEET_MEMBERSHIPS_DELETE: 'fleet:memberships:delete',
  FLEET_MEMBERSHIPS_MANAGE: 'fleet:memberships:manage',
  FLEET_INVITES_READ: 'fleet:invites:read',
  FLEET_INVITES_CREATE: 'fleet:invites:create',
  FLEET_INVITES_UPDATE: 'fleet:invites:update',
  FLEET_INVITES_DELETE: 'fleet:invites:delete',
  FLEET_INVITES_MANAGE: 'fleet:invites:manage',
  FLEET_VEHICLES_READ: 'fleet:vehicles:read',
  FLEET_VEHICLES_CREATE: 'fleet:vehicles:create',
  FLEET_VEHICLES_UPDATE: 'fleet:vehicles:update',
  FLEET_VEHICLES_DELETE: 'fleet:vehicles:delete',
  FLEET_VEHICLES_MANAGE: 'fleet:vehicles:manage',
  FLEET_BLUEPRINTS_READ: 'fleet:blueprints:read',
  FLEET_ROLES_READ: 'fleet:roles:read',
  FLEET_ROLES_CREATE: 'fleet:roles:create',
  FLEET_ROLES_UPDATE: 'fleet:roles:update',
  FLEET_ROLES_DELETE: 'fleet:roles:delete',
  FLEET_ROLES_MANAGE: 'fleet:roles:manage',
  FLEET_INVENTORIES_READ: 'fleet:inventories:read',
  FLEET_INVENTORIES_CREATE: 'fleet:inventories:create',
  FLEET_INVENTORIES_UPDATE: 'fleet:inventories:update',
  FLEET_INVENTORIES_DELETE: 'fleet:inventories:delete',
  FLEET_INVENTORIES_MANAGE: 'fleet:inventories:manage',
  FLEET_ALLIES_READ: 'fleet:allies:read',
  FLEET_ALLIES_CREATE: 'fleet:allies:create',
  FLEET_ALLIES_DELETE: 'fleet:allies:delete',
  FLEET_ALLIES_MANAGE: 'fleet:allies:manage',
  FLEET_CONTRACTS_READ: 'fleet:contracts:read',
  FLEET_CONTRACTS_CREATE: 'fleet:contracts:create',
  FLEET_CONTRACTS_UPDATE: 'fleet:contracts:update',
  FLEET_CONTRACTS_DELETE: 'fleet:contracts:delete',
  FLEET_CONTRACTS_MANAGE: 'fleet:contracts:manage',
  FLEET_MISSIONS_READ: 'fleet:missions:read',
  FLEET_MISSIONS_CREATE: 'fleet:missions:create',
  FLEET_MISSIONS_UPDATE: 'fleet:missions:update',
  FLEET_MISSIONS_DELETE: 'fleet:missions:delete',
  FLEET_MISSIONS_MANAGE: 'fleet:missions:manage',
  FLEET_EVENTS_READ: 'fleet:events:read',
  FLEET_EVENTS_CREATE: 'fleet:events:create',
  FLEET_EVENTS_UPDATE: 'fleet:events:update',
  FLEET_EVENTS_DELETE: 'fleet:events:delete',
  FLEET_EVENTS_MANAGE: 'fleet:events:manage',
  FLEET_PAYOUTS_READ: 'fleet:payouts:read',
  FLEET_PAYOUTS_CREATE: 'fleet:payouts:create',
  FLEET_PAYOUTS_UPDATE: 'fleet:payouts:update',
  FLEET_PAYOUTS_DELETE: 'fleet:payouts:delete',
  FLEET_PAYOUTS_MANAGE: 'fleet:payouts:manage',
  FLEET_NOTIFICATIONS_MANAGE: 'fleet:notifications:manage',
} as const;
